const MOCK_PACKAGE_NAMES_FA = {
  'Starter pasta': 'سبد آغازین پاستا',
  Family: 'سبد خانوادگی پاستا',
  'Kitchen premium': 'سبد ویژه آشپزخانه',
  'Bulk Referral Plan 01': 'طرح معرفی عمده ۰۱',
  'Bulk Referral Plan 02': 'طرح معرفی عمده ۰۲',
  'Bulk Referral Plan 03': 'طرح معرفی عمده ۰۳',
  'Bulk Referral Plan 04': 'طرح معرفی عمده ۰۴',
  'Bulk Referral Plan 05': 'طرح معرفی عمده ۰۵',
  'Bulk Referral Plan 06': 'طرح معرفی عمده ۰۶',
  'Bulk Referral Plan 07': 'طرح معرفی عمده ۰۷',
  'Bulk Referral Plan 08': 'طرح معرفی عمده ۰۸',
};

const MOCK_PLAN_PRODUCTS_FA = {
  'Savin Fettuccine Tomato 500g': 'فتوچینی گوجه‌ای ۵۰۰ گرمی',
  'Savin Plain Breadcrumbs 200g': 'پودر سوخاری ساده ۲۰۰ گرمی',
  'Savin Vegetable Farfalle Pasta': 'پروانه سبزیجات',
};

export const getPackageDisplayName = (name) => {
  if (name == null || name === '') return 'پکیج خرید گروهی';
  return MOCK_PACKAGE_NAMES_FA[String(name)] ?? String(name);
};

export const getProductDisplayName = (nameFa, nameEn) => {
  const persianName = String(nameFa ?? '').trim();
  if (persianName && /\p{Script=Arabic}/u.test(persianName)) return persianName;

  const englishName = String(nameEn ?? nameFa ?? '').trim();
  return MOCK_PLAN_PRODUCTS_FA[englishName] ?? 'کالا';
};
